export function filterGateway (origList, filterData) {
  return origList.filter(item => {
    return onlineFilter(item, filterData.status) && nameFilter(item, filterData.name)
  })
}

function nameFilter (item, name) {
  return item.name.includes(name)
}

function onlineFilter (item, status) {
  if (status === null) {
    return true
  }
  return item.status === status
}
